const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  userId: state => state.user.userId,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  realName: state => state.user.realName,
  plotId: state => state.user.plotId,
  foundId: state => state.user.foundId,
  role: state => state.user.role,
  power: state => state.user.power,
  loading: state => state.user.loading,
  setloading: state => state.user.setloading,
  pointX: state => state.user.pointX,
  pointY: state => state.user.pointY,
  permission_routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes
}
export default getters
